// SimpleHubs.js - Hub data for Simple mode hub purchases
// Players can buy these hubs to expand their network

export const SIMPLE_HUBS = [
  // North America
  { icao: 'KATL', name: 'Hartsfield-Jackson Atlanta International', city: 'Atlanta', region: 'North America', price: 55000000 },
  { icao: 'KJFK', name: 'John F. Kennedy International', city: 'New York', region: 'North America', price: 50000000 },
  { icao: 'KLAX', name: 'Los Angeles International', city: 'Los Angeles', region: 'North America', price: 45000000 },
  // Europe
  { icao: 'EGLL', name: 'Heathrow', city: 'London', region: 'Europe', price: 60000000 },
  { icao: 'LFPG', name: 'Charles de Gaulle', city: 'Paris', region: 'Europe', price: 50000000 },
  { icao: 'EDDF', name: 'Frankfurt', city: 'Frankfurt', region: 'Europe', price: 45000000 },
  // Middle East
  { icao: 'OMDB', name: 'Dubai International', city: 'Dubai', region: 'Middle East', price: 55000000 },
  // Asia
  { icao: 'VHHH', name: 'Hong Kong International', city: 'Hong Kong', region: 'Asia', price: 50000000 },
  { icao: 'WSSS', name: 'Changi', city: 'Singapore', region: 'Asia', price: 50000000 },
  { icao: 'RJTT', name: 'Haneda', city: 'Tokyo', region: 'Asia', price: 55000000 },
  // China
  { icao: 'ZSPD', name: 'Shanghai Pudong International', city: 'Shanghai', region: 'China', price: 80000000 },
  { icao: 'ZBAA', name: 'Beijing Capital International', city: 'Beijing', region: 'China', price: 80000000 },
  { icao: 'ZGGG', name: 'Guangzhou Baiyun International', city: 'Guangzhou', region: 'China', price: 80000000 },
  { icao: 'ZBAD', name: 'Beijing Daxing International', city: 'Beijing', region: 'China', price: 80000000 },
  { icao: 'ZUTF', name: 'Chengdu Tianfu International', city: 'Chengdu', region: 'China', price: 80000000 },
  { icao: 'ZSAM', name: 'Xiamen Gaoqi International', city: 'Xiamen', region: 'China', price: 80000000 },
  // Oceania
  { icao: 'YSSY', name: 'Kingsford Smith', city: 'Sydney', region: 'Oceania', price: 40000000 },
];
